import { inject, Pipe, PipeTransform } from '@angular/core'
import { TextTransformerService } from '@shared/services/text-transformer.service'

@Pipe({
	name: 'price',
})
export class PricePipe implements PipeTransform {
	private readonly _textTransformerService: TextTransformerService =
		inject<TextTransformerService>(TextTransformerService)

	transform(value: number | string | null | undefined, withSymbol: boolean = true): string {
		return this._textTransformerService.toPrice(value, withSymbol)
	}
}
